import { type BaseRequest, NotificationType, NurseFullRole } from "../../../utils/models";
import { hasNurseResponse } from "../../../utils/utilFunctions";

/**
 * Posted requests can store roles in either short-form (NurseRole) or long-form (NurseFullRole),
 * depending on the post path. This expands a list of selected role groups into the full set of
 * accepted role tokens — both forms — so callers can do a simple `includes` check.
 */
export const expandRoleGroupsToAcceptedRoles = (selectedRoleGroups: string[], roleGroups: Record<string, string[]> | undefined): string[] => {
	const accepted = new Set<string>();
	for (const groupName of selectedRoleGroups) {
		for (const shortRole of roleGroups?.[groupName] ?? []) {
			accepted.add(shortRole);
			const fullRole = NurseFullRole[shortRole as keyof typeof NurseFullRole];
			if (fullRole) accepted.add(fullRole);
		}
	}
	return [...accepted];
};

/** The Requests screen's response switch. Stable strings: they are the switch's option values. */
export enum RequestFilter {
	All = "all",
	WithResponse = "with_response",
	WithoutResponse = "without_response",
	ReplaceRequest = "replace_request",
}

/**
 * Whether a request passes the response switch — the one test both layouts of the Requests screen narrow by, and
 * the one the gaps layout counts each option with, so a count and the list it opens cannot disagree.
 */
export const matchesResponseFilter = (request: BaseRequest, filter: RequestFilter): boolean => {
	switch (filter) {
		case RequestFilter.All:
			return true;
		case RequestFilter.WithResponse:
			return hasNurseResponse(request);
		case RequestFilter.WithoutResponse:
			return !hasNurseResponse(request);
		case RequestFilter.ReplaceRequest:
			return request.request_type === NotificationType.ReplaceShift;
	}
};
